// Module
var code = `top: 0;
right: 0;
bottom: 0;
left: 0;
margin: auto;`;
// Exports
export default code;